import { useEffect } from 'react';

interface DocumentMetaOptions {
  title?: string;
  description?: string;
}

const defaultTitle = 'SurviAI - Convert Documents to Digital Surveys with AI';
const defaultDescription = 'Upload paper surveys, PDFs, or Word docs. Our AI extracts questions, detects types, and creates editable digital surveys in minutes.';

export function useDocumentMeta({ title, description }: DocumentMetaOptions = {}) {
  useEffect(() => {
    // Set title
    const fullTitle = title ? `${title} | SurviAI` : defaultTitle;
    document.title = fullTitle;

    // Set description meta tag
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || defaultDescription);
    }

    // Set OG title
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', fullTitle);
    }

    // Set OG description
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', description || defaultDescription);
    }

    // Set Twitter title
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', fullTitle);
    }

    // Set Twitter description
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', description || defaultDescription);
    }

    // Cleanup - restore defaults on unmount
    return () => {
      document.title = defaultTitle;
    };
  }, [title, description]);
}
